import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as PaperclipSvg } from './assets/paperclip.svg';

const PaperclipIcon = React.forwardRef((args, ref) => <SvgIcon component={PaperclipSvg} ref={ref} {...args} />);

export default PaperclipIcon;
